import React, { useState, useEffect } from "react";
import "./PracticeCourses.css";
import LeftSidebar from "../../components/LeftSideBar";
import CourseCard from "./CourseCard";
import { useNavigate } from "react-router-dom";
import fetchProtectedData from "../auth/ProtectDataHeader";
import withTokenRefresh from "../auth/RefreshToken";
import ReactGA from "react-ga4";
import SubscribeInfoModal from "../payment/SubscribeInfoModal";

ReactGA.send({ hitType: "pageview", page: "/topics", title: "Просмотрели страницу с топиками" });


function PracticeCourse() {
  const [loading, setLoading] = useState(true);
  const [courses, setCourses] = useState(null);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [infoText, setInfoText] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const protectedData = await withTokenRefresh(fetchProtectedData);
        if (!protectedData) {
          navigate("/login");
          return;
        }

        const response_courses = await fetch(`/api/course/available_courses/${protectedData}`, {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        });
        if (!response_courses.ok) {
          throw new Error(`HTTP error! status: ${response_courses.status}`);
        }

        const data_courses = await response_courses.json()
        const processedCourses = data_courses.courses
          .map((course) => {
            const progress = `${course.all_tasks_solved}/${course.all_tasks_count}`;
            return {
              title: course.course_name,
              title_front: course.front_name,
              is_open_for_everyone: course.is_open_for_everyone,
              progress: progress === "0/0" ? null : progress,
            };
          });
        setCourses(processedCourses)

      } catch (err) {
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [navigate]);

  if (loading) {
    return (
      <div className="progress-container">
        <div className="spinner"></div>
      </div>
    );
  }
  const totalTasksSolved = courses.reduce((acc, course) => {
    if (course.progress) {
      const [solved] = course.progress.split("/").map(Number);
      return acc + solved;
    }
    return acc;
  }, 0);

  const totalTasks = courses.reduce((acc, course) => {
    if (course.progress) {
      const [, total] = course.progress.split("/").map(Number);
      return acc + total;
    }
    return acc;
  }, 0);

  const totalProgress = `${totalTasksSolved}/${totalTasks}`;

  const openInfoModal = (text) => {
    if (text) {
      setInfoText(text);
    } else {
      setInfoText("");
    }
    setShowInfoModal(true);
  };

  const closeInfoModal = () => setShowInfoModal(false);


  const handleCardClick = (is_open_for_everyone, action) => {
    if (is_open_for_everyone === false) {
      openInfoModal("Для просмотра курса нужна подписка");
    } else {
      action()
    }
  };

  return (
    <div className="topics-container">
      <LeftSidebar />
      {showInfoModal && <SubscribeInfoModal onClose={closeInfoModal} text={infoText || undefined}/>}
      <div className="topics-main">
        <h1 className="topics-title">Выбери курс</h1>
        <h1 className="topics-subtitle">Здесь собраны все курсы с задачами</h1>
        <div className="topics-scrollable">
          {courses.map((course, index) => (
            <CourseCard
              key={index}
              title={course.title}
              title_front={course.title_front}
              progress={course.progress}
              is_open_for_everyone={course.is_open_for_everyone}
              onClick={() => handleCardClick(
                course.is_open_for_everyone,
                (() => navigate(`/practice?course_name=${course.title}`))
              )}
            />
          ))}
        </div>
        <div className="total-progress-card">
          <CourseCard
            title="Общий прогресс"
            title_front="Общий прогресс"
            progress={totalProgress}
            onClick={() => alert("Total Progress Clicked!")}
            is_open_for_everyone={true}
          />
        </div>
      </div>
    </div>
  );
}

export default PracticeCourse;
